/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'project-actions.project-content.archive-error-title': 'No se ha podido restaurar el proyecto',
  'project-actions.project-content.archive-project': 'Archivar proyecto',
  'project-actions.project-content.archive-restore-error-description':
    'No se han guardado los cambios del proyecto. Inténtalo de nuevo más tarde.',
  'project-actions.project-content.copy-link': 'Copiar enlace',
  'project-actions.project-content.copy-project': 'Copiar proyecto',
  'project-actions.project-content.copy-project.cancel': 'Cancelar',
  'project-actions.project-content.copy-project.close-modal': 'Cerrar modal',
  'project-actions.project-content.copy-project.error':
    'Dale un nombre a tu proyecto para que todo el mundo sepa de qué se trata',
  'project-actions.project-content.copy-project.failed-description':
    'Se ha producido un error al clonar el proyecto. Inténtalo de nuevo más tarde.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'No tienes permiso para copiar este proyecto.',
  'project-actions.project-content.copy-project.failed-title': 'No hemos podido clonar este proyecto.',
  'project-actions.project-content.copy-project.followers': 'Seguidores',
  'project-actions.project-content.copy-project.include': 'Incluir',
  'project-actions.project-content.copy-project.links': 'Enlaces',
  'project-actions.project-content.copy-project.project-name': 'Nombre del proyecto',
  'project-actions.project-content.copy-project.submit': 'Enviar',
  'project-actions.project-content.copy-project.success-description': 'El proyecto se ha clonado correctamente.',
  'project-actions.project-content.copy-project.success-link': 'Ver proyecto clonado.',
  'project-actions.project-content.copy-project.success-title': 'Proyecto {projectName} clonado.',
  'project-actions.project-content.copy-project.title': 'Copiar proyecto',
  'project-actions.project-content.follow': 'Seguir',
  'project-actions.project-content.follow-confirmation-description':
    'Todos los lunes por la mañana te enviaremos un resumen con las actualizaciones de todos los proyectos que sigues. ¿Por qué los lunes? <a>Lee aquí</a>.',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 ¡Ahora estás siguiendo este proyecto!',
  'project-actions.project-content.follow-error-title': 'No se ha podido realizar el seguimiento del proyecto',
  'project-actions.project-content.follow-unfollow-error-description':
    'No se han guardado los cambios del proyecto. Inténtalo de nuevo más tarde.',
  'project-actions.project-content.restore-project': 'Restaurar proyecto',
  'project-actions.project-content.share': 'Compartir',
  'project-actions.project-content.unfollow': 'Dejar de seguir',
  'project-actions.project-content.unfollow-error-title': 'No se ha podido dejar de seguir el proyecto',
};
